
































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import {
  List,
  Checkbox,
  CheckboxGroup,
  Button,
  Lazyload,
  Dialog,
  Toast,
} from 'vant';
import { getVoteList } from '../api';

Vue.use(List)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Lazyload)
  .use(Dialog)
  .use(Button)
  .use(Toast);

@Component
export default class VoteList extends Vue {
  @Prop() listType!: any;

  loading = false;
  finished = false;
  page = 1;
  getListData: any[] = [];
  tempData = [];
  // 初使加载
  async onLoad() {
    this.loading = true;
    const res = await getVoteList(this.listType, this.page);
    this.fetchListData(res);
  }
  fetchListData(res: any) {
    if (res.status === 1 || res.code === 500 || res.msg === '暂无数据') {
      this.finished = true;
    } else {
      this.getListData = [...this.getListData, ...res.data];
      this.page = this.page + 1;
      this.finished = false;
    }
    this.loading = false;
  }
  // 进入详情页
  enterDetailPage(item: any) {
    this.$router.push({
      path: 'detail',
      query: {
        id: item.id,
      },
    });
    this.$emit('enterDetailPage', item.id);
  }

  @Watch('listType', {
    immediate: true,
  })
  onListTypeChanged() {
    this.loading = false;
    this.finished = false;
    this.page = 1;
    this.getListData = [];
    this.onLoad();
  }
  htmlToText(text: string) {
    const reg = /<[^<>]+>/g; // 1、全局匹配g肯定忘记写,2、<>标签中不能包含标签实现过滤HTML标签
    text = text.replace(reg, ''); // 替换HTML标签
    text = text.replace(/&nbsp;/gi, '').replace(/^\s+|\s+$/g, ''); // 替换HTML空格
    return text;
  }
}
